import { ChangeDetectorRef, Component, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { CommonService } from '../common-service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard';
import { MarkdownService } from '../markdown-service';
import * as moment from 'moment';
import { MdEditorOption } from 'ngx-markdown-editor/public_api';
import { MessageService } from 'primeng/api';
import { SanitizationService } from '../sanitization.service';
import { ActivatedRoute, Route } from '@angular/router';
import { Action } from 'rxjs/internal/scheduler/Action';
import { saveAs } from 'file-saver';
import { QuestionService } from '../question.service';


@Component({
  selector: 'app-task-work',
  templateUrl: './task-work.component.html',
  styleUrl: './task-work.component.scss'
})
export class TaskWorkComponent implements OnInit {
  DefaultPrompts: any[]=[];
  taskContent: any='';
  template_purpose: any;
  tag_code: any;
  isloading!: boolean;
  responseData: any[]=[];
  Tags:string=''
  isExpanded: boolean=false;
  submitted: boolean=false;
  isCopied: boolean=false;
  label: any='';
  params: any[] = [];
counts!:number
public editorOptions: MdEditorOption = {
  showPreviewPanel: true,
  resizable: true,
  fontAwesomeVersion: '6',
  markedjsOpt: {
    sanitize: true
  }
};
options={
  lineNumbers: true,
  theme: 'material',
   mode: 'javascript',
  direction: 'ltr',
  
}
@ViewChild('codeEditor', { static: false }) codeEditor: any;
  
typeOptions = ['text', 'int', 'date','search'];
dialogTitle: string = 'Change Script'
activeTab: string = 'task';
public mode: string = 'editor';
  username: string | null;
  taskLogs: any[]=[];
  temp_Data:any={};
  temp_code: any;
  filteredTaskLog: any;
  template_name: any;
  prompt: any='';
  template_script: any;
  openScriptmodal: boolean=false;
  temp_id: any;
  selectedAILogContent: string='';
  openlogModal: boolean=false;
  aidialogTitle: string='';
  originalPrompt: any;
  updatescript: boolean=false;
  originalScript: any;
  role: string | null;
  saveTemp: boolean=false;
  activateTestbtn: boolean=false;
  today: any;
  startDate: string;
  endDate: string;
  pagenumber: any=1;
  loader: boolean=false;
  rows: number = 10;
  totalrecords = 0
  first: number = 0;
  searchTerm: any;
  selectedDateRange: any[]=[];
  paramloading: boolean=false;
  dLoader: boolean=false;
  availableCollections: any[] = [];
  selectedCollection: string = '';
  readonly: boolean=false;
  islogCopied: boolean=false;
  constructor(private api:CommonService,private sanitizer: DomSanitizer,private clipboard: Clipboard,private markdownService: MarkdownService,private messageService: MessageService,public sanitizeService:SanitizationService,
    private route:ActivatedRoute, private cdr: ChangeDetectorRef,private qusService:QuestionService  ){
    this.username = localStorage.getItem('username');
    this.role = localStorage.getItem('role');
    const storedTagList = localStorage.getItem('tagList');
    this.DefaultPrompts = storedTagList ? JSON.parse(storedTagList) : [];  
     this.startDate = this.getTodayDate(); 
     this.endDate=this.getTodayDate();
  }

  ngOnInit(): void {
    this.api.selectedTemplate$.subscribe((template) => {
      this.temp_Data = JSON.parse(template);   
      if(this.temp_Data){
        this.selectedtag(this.temp_Data.template_code)
        const downloadStatus = localStorage.getItem(`download_status_${this.temp_Data.template_code}`);
      this.handleDownloadStatus(downloadStatus);
      this.temp_code = this.temp_Data.template_code;
    }else{
      this.selectedtag(this.DefaultPrompts[0].template_code);
      this.temp_code = this.DefaultPrompts[0].template_code
    }
    this.taskContent='';
    });
    this.readonly = (this.role == 'admin' && this.temp_code !== 'SYSTASK') || (this.role === 'system admin' && this.temp_code == 'SYSTASK');
      if ((this.role == 'admin' && this.temp_code !== 'SYSTASK') || (this.role === 'system admin' && this.temp_code == 'SYSTASK')) {
      this.activeTab = 'task';
    }else{this.activeTab= 'execute'}
      }

selectedtag(code: any) {
  this.searchTerm='';
  this.api.getMethod(`api/v1/get_template?template_code=${code}`).subscribe((data:any)=>{
    const selectedTemplate = data.data 
  if (selectedTemplate) {
    this.Tags=selectedTemplate.template_name;
    this.prompt=selectedTemplate.template_text.replace(/\\n/g, '\n');
    this.temp_code=selectedTemplate.template_code;
    this.template_script=selectedTemplate.post_processor,
    this.template_purpose = selectedTemplate.template_purpose;
    this.temp_id=selectedTemplate.id;
    this.params = selectedTemplate.params || [];
    this.originalPrompt=this.prompt;
    this.originalScript=this.template_script;
    this.responseData=[];
    const today = moment().toDate();
    this.selectedDateRange = [today, today];
    this.startDate = moment(today).format('YYYY-MM-DD');
    this.endDate = moment(today).format('YYYY-MM-DD');
    this.loadCollections();
    this.fetchtaskworkLogs();
  } else {
    this.template_purpose = '';
    this.params = [];
  }
});
}

changeCollection(param: any) {
  param.value = '';
  param.filteredQuestions = [];
  this.params[0].displayText='';
}

loadCollections() {
  this.api.getMethod('get-collections/v2').subscribe((res: any) => {
    this.availableCollections = res.map((col: any) => ({
      collectionName: col.collectionName,
      collectionId: col.collection_id,
    }));
    this.selectedCollection = localStorage.getItem('selectedCollection') ? localStorage.getItem('selectedCollection') : this.availableCollections[0].collectionName;

  });
}
onQuestionSelect(event: any, param: any) {
  param.value = event.value.id;
  param.displayText =event.value.question;
}

searchQuestions(event: any, param: any) {
  const query = event.query;
  if (!this.selectedCollection || query.length < 2) {
    param.filteredQuestions = [];
    return;
  }
  
  const payload = {
    collectionName: this.selectedCollection,
    question: query,
    attributes: [
      "id",
      "question",
      "answer",
      "collection_name"
    ]
  };

  this.qusService.faqssearch(payload).subscribe({
    next: (res: any) => {
      param.filteredQuestions = res.data || [];
    },
    error: (err: any) => {
      console.error('Error searching questions:', err);
      param.filteredQuestions = [];
    }
  });
}
isFormValid(): any {
    if (this.temp_code === 'SYSTASK') {
    return this.params
      .filter(param => param.type === 'search')
      .every(param => !!(param.displayText && param.displayText.trim() !== ''));
  } return this.Tags.length > 0 && this.taskContent.length > 0;
}
setActiveTab(tab: string): void {
  this.searchTerm='';
  this.activeTab = tab;
  if( this.activeTab=='execute'){
this.selectedtag(this.temp_code)
  }
  
}
onPageChange(event:any) {
  this.loader=true
  this.first = event.first;
  this.pagenumber = event.page+1;
  this.fetchtaskworkLogs();
}
 getTodayDate(): string {
  const today = new Date();
  return today.toISOString().split('T')[0];
}
generateResponse() {
  this.submitted=true
  if(this.isFormValid()){
    const formData = this.params.reduce((acc, param) => {
      if (param.type === 'date' && param.value) {
        acc[param.name] = this.formatDate(param.value);
      }else if (param.type == 'search' && param.name == 'question') {
        acc['question_id'] = param.value.toString();}
         else {
        acc[param.name] = param.value;
      }
      return acc;
    }, {});
  const htmlTaskContent = this.markdownService.convertToHtml(this.taskContent);
  let payload = {
    template_code: this.temp_code,
    content: htmlTaskContent,
    params:formData
  };
  this.isloading = true;
  this.api.postMethod('api/v1/generate_content_meta', payload).subscribe({
    next: (response: any) => {
      const markdownContent = response.data;
      if (typeof markdownContent === 'string') {
        this.handleResponse(formData,markdownContent.replace(/\n/g, '<br>'));
      }  else if (typeof markdownContent === 'object') {
        const objectAsString = JSON.stringify(markdownContent, null, 2);
        this.handleResponse(formData, objectAsString.replace(/\n/g, '<br>'));}
        else  if (markdownContent && typeof markdownContent.then === 'function'){
        markdownContent.then((resolvedContent: string) => {
          this.handleResponse(formData,resolvedContent.replace(/\n/g, '<br>'));
        }).catch((error:any) => {
          console.error("Error occurred while processing response:", error);
          this.isloading = false;
        });
      }

      this.fetchtaskworkLogs();
    },
    error: (error) => {
      console.error("Error occurred while making API call:", error);
      this.handleResponse(null,error.error.message)
      this.isloading = false;
    }
  });
}
}
formatDate(date: Date): string {
  return moment(date).format('DoMMMMYYYY');
}

private handleResponse(formData: any, content: string) {
  let rescontent = this.sanitizer.bypassSecurityTrustHtml(content);
  let formattedParams = Object.keys(formData).length
    ? Object.entries(formData).map(([k, v]) => `${k}: ${v}`).join(', ')
    : null;

  this.responseData.unshift({
    params: formattedParams, // can be null or string
    response: rescontent
  });

  this.isloading = false;
} 


downloadContent(responseData: any[]) {
  if (!responseData || responseData.length === 0) {
    console.error('No data to download');
    return;
  }

  let content: string;

  if (responseData[0]?.params) {
    content = responseData
      .map(entry => {
        let sanitizedResponse = this.sanitizer.sanitize(SecurityContext.HTML, entry.response) || '';
        sanitizedResponse = sanitizedResponse.replace(/<br\s*\/?>/gi, '\n'); // Convert <br> to new lines
        return `Params: ${entry.params || 'Not Provided'}\nResponse:\n${sanitizedResponse}`;
      })
      .join('\n\n'); 
  } else {
    // Case: No params, just response
    let sanitizedResponse = this.sanitizer.sanitize(SecurityContext.HTML, responseData[0]?.response) || '';
    sanitizedResponse = sanitizedResponse.replace(/<br\s*\/?>/gi, '\n'); // Convert <br> to new lines
    content = sanitizedResponse || 'No response available';
  }

  const blob = new Blob([content], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'downloadedContent.txt';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}


  copyContent(responseData: any[]) {
    if (!responseData || responseData.length === 0) {
      console.error('No data to copy');
      return;
    }

    let content: string;

    if (responseData[0]?.params) {
      // Case: responseData contains params
      content = responseData
        .map(entry => {
          let sanitizedResponse = this.sanitizer.sanitize(SecurityContext.HTML, entry.response) || '';
          sanitizedResponse = sanitizedResponse.replace(/<br\s*\/?>/gi, '\n'); // Convert <br> to new lines
          return `Params: ${entry.params || 'Not Provided'}\nResponse:\n${sanitizedResponse}`;
        })
        .join('\n\n'); 
    } else {
      // Case: No params, just response
      let sanitizedResponse = this.sanitizer.sanitize(SecurityContext.HTML, responseData[0]?.response) || '';
      sanitizedResponse = sanitizedResponse.replace(/<br\s*\/?>/gi, '\n'); // Convert <br> to new lines
      content = sanitizedResponse || 'No response available';
    }

    // Copy to clipboard
    this.clipboard.copy(content);
    console.log('Content copied to clipboard!');
  }

  showDialog() {
    this.openScriptmodal = true; // Open p-dialog
    setTimeout(() => {
      this.codeEditor?.codeMirror.refresh(); // Refresh CodeMirror
    }, 300); // Delay to ensure the dialog is fully rendered
  }
  onDialogHideaddcollection(){
    this.openScriptmodal=false;
  }
  refreshLogpage(){
    this.dLoader=false;
    const today = moment().toDate();
    this.selectedDateRange = [today, today];
    this.startDate = moment(today).format('YYYY-MM-DD');
    this.endDate = moment(today).format('YYYY-MM-DD');
    setTimeout(()=>{this.fetchtaskworkLogs()},1000);
  }
  toggleFullScreen() {
    this.isExpanded = !this.isExpanded;
  }
  handleDateSelection() {
    if (this.selectedDateRange && this.selectedDateRange.length === 2) {
      this.startDate = moment(this.selectedDateRange[0]).format('YYYY-MM-DD');
      this.endDate =this.selectedDateRange[1]? moment(this.selectedDateRange[1]).format('YYYY-MM-DD'): this.endDate;
    }  
  }
  fetchtaskworkLogs(){
    this.searchTerm='';
    let payload={
      "page": this.pagenumber,
      "limit": 10,
      "username": this.username,
      "date_from":this.startDate ,
      "date_to": this.endDate,
       "template_code":this.temp_code
  }
  this.loader=true;
    this.api.postMethod(`api/v1/template-logs`,payload).subscribe({
      next:(res:any)=>{this.taskLogs = res.data;  
                                               
      this.filteredTaskLog = [...this.taskLogs];
      this.totalrecords = res.pagination.total_records;
      this.rows = res.pagination.records_per_page;
      this.loader = false;
    
      },
      error:(err)=>{
        this.loader=false;
        this.messageService.add({ severity: 'error', detail: err.error.message });
        console.error('Error in fetching taskworklog ', err);
      }})
  }
  sanitizeMessage(message: string): SafeHtml {
    return this.sanitizeService.sanitizeMessage(message);
   }
   filterData() {
    this.filteredTaskLog = this.taskLogs.filter(item => item.template_code == this.temp_code);
  }
  onClickRescan(prompt:any){
  this.paramloading=true;
    const regex = /{%([\w\d_]+)%}/g;
    let match;
    const extractedParams: any[] = [];
    setTimeout(() => { 
      while ((match = regex.exec(prompt)) !== null) {
          const paramName = match[1];
          const existingParam = this.params.find(p => p.name == paramName);
        extractedParams.push({
          name: match[1], // Extract only variable name
          type: "text",   // Reset type to default "text"
          label: existingParam ? existingParam.label : ''  
        });
      }
          this.params= extractedParams;
      this.paramloading = false; 
    }, 1000); 
  

  }
  OpenScriptModal(){
    this.openScriptmodal=true;
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 100);

  }
  revrtScript(){
    this.template_script=this.originalScript;
  }
  closeScript(){
    this.openScriptmodal=false;
  }
  updateScript(){
    if(this.originalScript==this.template_script){
      this.messageService.add({ severity: 'warn', detail: "There is no changes made in Script!" });
      return ;
    }else{
      this.updatescript=true;
    let body={
      "post_processor": this.template_script?this.template_script : 'return data;'
  }
    this.api.putMethod(`api/v1/update_template_fields/${this.temp_id}`,body).subscribe({
      next:(data:any)=>{
        this.template_script=data.data.post_processor;
      this.messageService.add({ severity: 'success', detail: data.message });
      this.openScriptmodal=false;
      this.updatescript=false;
    },
      error:(err)=>{
        this.messageService.add({ severity: 'error', detail: err.error.message });
        console.error('Error in updating script ', err);
        this.updatescript=false;
      } });
    }
  }
  saveTemplateChanges(){

    let body={
      "template_text": this.prompt,
      "params": this.params,
      "template_purpose": this.template_purpose
  }
  this.saveTemp=true;
    this.api.putMethod(`api/v1/update_template_fields/${this.temp_id}`,body).subscribe({
      next:(data:any)=>{
      this.activateTestbtn=true;
      this.messageService.add({ severity: 'success', detail: data.message });
      this.selectedtag(this.temp_code);
      this.saveTemp=false;
    },
      
      error:(err)=>{
        this.saveTemp=false;
        this.messageService.add({ severity: 'error', detail: err.error.message });
        console.error('Error in updating script ', err);
      } });
    
  }
  
  openModal(content: string,heading:any) {
    this.selectedAILogContent = content;
    this.openlogModal=true;
    this.aidialogTitle=heading;
}
clicktoTest(){
  this.setActiveTab('execute');
}
 stripHtmlTags(input: string): string {
  return input.replace(/<[^>]*>/g, '').trim();
}



downloadLog() {
  const payload = {
    username: this.username,
    date_from: this.startDate,
    date_to: this.endDate,
    template_code: this.temp_code
  };

  this.dLoader = true;
  localStorage.setItem(`download_status_${this.temp_code}`, 'in-progress');
  this.api.postMethod(`api/v1/template-logs`, payload).subscribe({
    next: (res: any) => {
      const fullLogs = res.data;

      if (!fullLogs || fullLogs.length === 0) {
        this.messageService.add({ severity: 'warn', detail: 'No logs to export' });
        this.dLoader = false;
        localStorage.setItem(`download_status_${this.temp_code}`, 'no-data');
        return;
      }

      const sortedLogs = [...fullLogs].sort((a: any, b: any) => {
        return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
      });

      const excludedFields = ['username', 'ai_model', 'session_id', 'message_id'];
      const filename = `task_logs_${new Date().toISOString()}.xlsx`;

      const worker = new Worker(new URL('../workers/xlsx-generator.worker', import.meta.url), {
        type: 'module',
      });

      worker.onmessage = ({ data }) => {
        const blob = new Blob([data.blob], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, data.filename);
        this.dLoader = false;
        localStorage.setItem(`download_status_${this.temp_code}`, 'completed');
        this.messageService.add({ severity: 'success', detail: 'Logs are downloaded successfully.' });

        worker.terminate();
      };

      worker.postMessage({ logs: sortedLogs, excludedFields, filename });
    },
    error: (err: any) => {
      this.dLoader = false;
      localStorage.setItem(`download_status_${this.temp_code}`, 'error');
      this.messageService.add({ severity: 'error', detail: err.error.message });
      console.error('Error in downloading logs', err);
    }
  });
}

handleDownloadStatus(status: string | null) {
  switch (status) {
    case 'in-progress':
      this.dLoader = true;
      break;
    case 'completed':
      this.messageService.add({ severity: 'success', detail: 'Logs are downloaded successfully.' });
      break;
    case 'error':
    case 'failed':
      this.messageService.add({ severity: 'error', detail: 'Previous download failed. Try again.' });
      break;
    case 'no-data':
      this.messageService.add({ severity: 'warn', detail: 'No logs found in previous attempt.' });
      break;
    default:
      // No previous status
      this.dLoader = false;
  }
}

   formatcreateDate(date: string | null): string {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return date;
  
    const day = d.getUTCDate().toString().padStart(2, '0');
    const month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getUTCMonth()];
    const year = d.getUTCFullYear();
    let hrs = d.getUTCHours(), mins = d.getUTCMinutes().toString().padStart(2, '0');
    const ampm = hrs >= 12 ? 'pm' : 'am';
    hrs = hrs % 12 || 12;
  
    return `${day} ${month} ${year}, ${hrs}:${mins} ${ampm}`;
  }
  
filterLogs() {
  const search = this.searchTerm.toLowerCase().trim();

  // If search is empty, reset the list and keep pagination
  if (!search) {
    this.filteredTaskLog = [...this.taskLogs]; 
    return;
  }

  // Apply filtering to the full dataset
  this.filteredTaskLog = this.taskLogs.filter(log => {
    const formattedDate = new Date(log.created_at).toLocaleString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true
    }).replace(',', '');
    const paramsString = JSON.stringify(log.template_params || {}).toLowerCase();

    return (
      log.req_content.toLowerCase().includes(search) ||
      log.ai_content_response.toLowerCase().includes(search) ||
      log.template_code.toLowerCase().includes(search) ||
      formattedDate.includes(search) ||
      paramsString.includes(search)
    );
  });
}
copylogToClipboard(){
  if (this.clipboard.copy(this.selectedAILogContent)) {
    this.islogCopied=true;
    setTimeout(() => {
      this.islogCopied= false;
    }, 2000);
    console.log('Content copied to clipboard successfully!');
  } else {
    // Handle the error scenario
    console.error('Failed to copy content to clipboard.');
  }
}
copyToClipboard() {
  if (this.clipboard.copy(this.template_script)) {
    this.isCopied=true;
    setTimeout(() => {
      this.isCopied= false;
    }, 2000);
    console.log('Content copied to clipboard successfully!');
  } else {
    // Handle the error scenario
    console.error('Failed to copy content to clipboard.');
  }
}


highlightText(text: string): string {
  if (!this.searchTerm || !text) return text;

  const regex = new RegExp(`(${this.searchTerm})`, 'gi');
  return text.replace(regex, `<span class="highlight">$1</span>`);
}
resetLog(){
  let today=new Date()
  this.startDate=this.getTodayDate();
  this.endDate=this.getTodayDate();
  this.selectedDateRange = [today];
 setTimeout(()=>{ 
  this.fetchtaskworkLogs()},1000)
}
}
